export const firebaseConfig = {
    apiKey: "AIzaSyBfnH7vLb9JhKyCx6cucXzWgCFK3q54zoI",
    authDomain: "entropy-spot-landing.firebaseapp.com",
    databaseURL: "https://entropy-spot-landing.firebaseio.com",
    projectId: "entropy-spot-landing",
    storageBucket: "entropy-spot-landing.appspot.com",
    messagingSenderId: "526362842372",
    appId: "1:526362842372:web:d31d2070b745d6a6e1ac51"
};
